import clsx from 'clsx';
import { cva } from 'cva';
import React from 'react';

const chip = cva('chip', {
  variants: {
    color: {
      primary: ['bg-chips-primary'],
      primarydark: ['bg-chips-primary-dark'],
      secondary: ['bg-chips-secondary'],
      secondarydark: ['bg-chips-secondary-dark'],
      tomato: ['bg-chips-tomato'],
      mulberry: ['bg-chips-mulberry'],
      amber: ['bg-chips-amber'],
      steelBlue: ['bg-chips-steel-blue'],
      gray: ['bg-chips-gray'],
      lightCoral: ['bg-chips-light-coral'],
      kellyGreen: ['bg-chips-kelly-green'],
      transparent: ['bg-transparent'],
    },
    edge: {
      rounded: ['rounded-2xl'],
      sharp: ['rounded-none'],
    },
    padding: {
      narrow: ['px-3 py-1'],
      default: ['px-3 py-2'],
    },
    text: {
      small: ['text-12'],
      default: ['text-14'],
    },
  },
  defaultVariants: {
    color: 'primary',
    edge: 'rounded',
    padding: 'default',
    text: 'default',
  },
});

function Chip(props) {
  const { color, edge, padding, text, children, className, ...rest } = props;
  return (
    <div
      className={clsx(
        chip({ color, edge, padding, text }),
        'truncate text-center font-dmsans font-normal text-text-primary',
        className,
      )}
      {...rest}>
      {children}
    </div>
  );
}

export default Chip;
